var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpoonKnifeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_13643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.72706 6.74573L5.50314 4.87534L1.09746 0.242329C0.6273 0.738881 0.363281 1.41149 0.363281 2.11272C0.363281 2.81394 0.6273 3.48655 1.09746 3.98311L3.72706 6.74573ZM7.98212 5.54947C8.94234 6.01872 10.2917 5.68826 11.2895 4.63741C12.4882 3.37506 12.7204 1.56416 11.7979 0.592614C10.8816 -0.372322 9.16199 -0.134392 7.95702 1.12795C6.95915 2.17881 6.64536 3.59977 7.09095 4.61097L0.965666 11.0615L1.85057 11.9934L6.17466 7.45291L10.4925 12L11.3774 11.0681L7.05957 6.52102L7.98212 5.54947Z",
    fill: "#D3D3D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_13643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.363281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpoonKnifeIcon);
export default __webpack_public_path__ + "static/media/SpoonKnifeIcon.2a921313e693f0cd29bd97163a2bd628.svg";
export { ForwardRef as ReactComponent };